import { decryptFileAES, encryptFileAES } from "../Utils/OstreonEncryption";
import config from "../config";
import JSZip from "jszip";

const base_url = config.base_url;
export const UploadFiles = async (
  files,
  private_key,
  Progress = () => {},
  translations,
  /*
    Whose storage this belongs in.

    Absent, the file lands in the uploader's own directory -- which is right
    for a customer and wrong for a partner, whose own directory the customer
    cannot read. Given, it goes through the partner endpoint and into the
    CUSTOMER's directory, which is where a proposal naming it will be looked
    for. The bytes are encrypted under the customer's key either way.
  */
  customer_id = null
) => {
  const simulateActivity = () => {
    const event = new MouseEvent("mousemove", {
      view: window,
      bubbles: true,
      cancelable: true,
    });
    document.dispatchEvent(event);
  };
  const intervalId = setInterval(simulateActivity, 300);
  return new Promise(async (resolve, reject) => {
    if (files.length === 0) return resolve();
    // `intervalId` is cleared on every exit below, including the new ones.
    const formData = new FormData();
    for (let file of files) {
      Progress(
        `${translations?.encrypting} ${file.name}` || `Encrypting ${file.name}`
      );
      const encrypted_file = await encryptFileAES(private_key, file);
      /*
        encryptFileAES catches its own failure and resolves to UNDEFINED
        rather than throwing. Appended, that becomes the literal string
        "undefined" as a text field: the server sees no files at all, the
        customer's /file/upload answers 200 regardless, and the caller goes
        on to record a reference to a file that was never written. Nothing
        reports an error at any point.

        So this is checked here. One file that will not encrypt fails the
        whole upload, because a partial upload is the thing the caller
        cannot detect.
      */
      if (!(encrypted_file instanceof File) && !(encrypted_file instanceof Blob)) {
        clearTimeout(intervalId);
        return reject(new Error(`Could not encrypt ${file.name}`));
      }
      formData.append("file", encrypted_file);
    }
    if (customer_id) formData.append("customer_id", customer_id);
    Progress(translations?.uploading_files || `Uploading files`);
    fetch(base_url + (customer_id
      ? "user/partner/customer/file/upload"
      : "user/file/upload"), {
      method: "POST",
      mode: "cors",
      credentials: "include",
      body: formData,
    })
      .then((res) => {
        if (res.status === 200) {
          clearTimeout(intervalId);
          // Progress('Upload completed!')
          resolve();
        } else {
          clearTimeout(intervalId);
          reject();
        }
      })
      .catch((e) => {
        clearTimeout(intervalId);
        reject("An error occurred");
      });
  });
};
export const decryptBase64file = (private_key, base64String) => {
  return new Promise(async (resolve, reject) => {
    try {
      const binaryString = atob(base64String);
      const len = binaryString.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      const image_blob = new Blob([bytes]);
      const image_file = new File([image_blob], "avatar");
      // console.log(image_file)
      const decrypted_avatar = await decryptFileAES(private_key, image_file);
      if (!decrypted_avatar) return resolve(null);
      // console.log('ha decryptado')
      // console.log(decrypted_avatar)
      var reader = new FileReader();
      reader.readAsDataURL(decrypted_avatar);
      reader.onload = () => resolve(reader.result.split(",")[1]);
      reader.onerror = () => resolve(null);
      // resolve(reader.readAsDataURL(decrypted_avatar));
    } catch (error) {
      console.log(error);
      reject(error);
    }
  });
};
export const base64toFile = (base64String, filename) => {
  try {
    const binaryString = atob(base64String);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    const blob = new Blob([bytes]);
    const file = new File([blob], filename);
    return file;
  } catch (error) {
    console.log(error);
    return null;
  }
};
export const renameFile = (file, newFileName) => {
  return new File([file], newFileName, { type: file.type });
};
// const encryptFile = (private_key, file) =>{
//     return new Promise((resolve, reject) => {
//         if (file==='undefined' || typeof(file)!='object') return null
//         file.arrayBuffer()
//         .then(bufData=>encrypt(private_key, bufData))
//         .then((encrypted)=>{
//             const encryptedBlob= new Blob([encrypted])
//             const encryptedFile= new File([encryptedBlob], 'encrypted_'+file.name)
//             resolve(encryptedFile)
//         }).catch(e=>{
//             console.log(e)
//             reject(null)
//         })
//     })
// }

// const decryptFile = (private_key, file) =>{
//     return new Promise((resolve, reject) => {
//         if (file==='undefined' || typeof(file)!='object') reject(null)
//         new Blob([file]).text()
//         .then(saltIvCipherHex=>{
//             return decrypt(private_key, saltIvCipherHex)
//         }).then(decryptedBuffer=>{
//             const decryptedBlob = new Blob([decryptedBuffer])
//             const decryptedFile= new File([decryptedBlob], file.name)
//             resolve(decryptedFile)

//         }).catch(e=>{
//             console.log(e)
//             reject(null)
//         })
//     })
// }

/*
  `customer_id` is set only when a partner opens a file on a customer's shared
  asset, and it switches the request to the partner endpoint.

  It has to switch, because /user/file/download resolves the path from whoever
  is logged in -- for a partner that is the partner's own folder, where a
  customer's file has never been. The partner route reads the customer's folder
  instead, after checking the file belongs to an asset shared with share_files.

  Nothing below changes. The bytes come back encrypted under the customer's key
  either way, and in the partner view `private_key` IS that key.
*/
/*
  One stored file, fetched and opened, handed back rather than saved.

  The same request downloadFile makes, minus the browser download at the
  end -- separate because not every caller wants one: accepting a partner's
  suggested profile picture needs the bytes, to hand to the picture
  endpoint.

  `customer_id` routes through the partner endpoint, which checks that this
  partner may read this customer's files and streams them still encrypted.
*/
export const fetchDecryptedFile = async (
  file_id,
  filename,
  private_key,
  customer_id = null
) => {
  const body = new URLSearchParams({ file_id });
  if (customer_id) body.set("customer_id", customer_id);
  const res = await fetch(
    base_url +
      (customer_id
        ? "user/partner/customer/file/download"
        : "user/file/download"),
    {
      method: "POST",
      mode: "cors",
      credentials: "include",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      body: body.toString(),
    }
  );
  if (res.status !== 200) throw new Error(String(res.status));
  const blob = await res.blob();
  return decryptFileAES(private_key, new File([blob], filename));
};

export const downloadFile = async (
  file_id,
  filename,
  private_key,
  Progress = () => {},
  translations,
  customer_id = null
) => {
  // console.log("Downloading...");
  // console.log(file_id);
  // console.log(filename);
  // console.log(private_key);
  Progress(
    `${translations.downloading} ${filename}` || `Downloading ${filename}...`
  );
  return new Promise((resolve, reject) => {
    const body = new URLSearchParams({ file_id });
    if (customer_id) body.set("customer_id", customer_id);
    fetch(base_url + (customer_id
      ? "user/partner/customer/file/download"
      : "user/file/download"), {
      method: "POST",
      mode: "cors",
      credentials: "include",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      body: body.toString(),
    })
      .then((res) => {
        if (res.status !== 200) {
          throw new Error(res.status);
        } else {
          // console.log("file_downloaded");
          return res.blob();
        }
      })
      .then(async (blob) => {
        Progress(
          `${translations.decrypting} ${filename}` ||
            `Decrypting ${filename}...`
        );
        // console.log("ha llegado");
        const encrypted_file = new File([blob], filename);
        // console.log("es blob");
        const decrypted_file = await decryptFileAES(
          private_key,
          encrypted_file
        );
        const url = URL.createObjectURL(decrypted_file);
        resolve();
        const link = document.createElement("a");
        link.href = url;
        link.download = decrypted_file.name;
        document.body.appendChild(link);
        link.click();
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const downloadLocalFile = async (file, fileName) => {
  console.log("Downloading...");
  const url = URL.createObjectURL(file);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
};
export const DeleteFile = async (file_id) => {
  return new Promise((resolve, reject) => {
    fetch(base_url + "user/file/delete", {
      method: "POST",
      mode: "cors",
      credentials: "include",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      body: `file_id=${file_id}`,
    })
      .then((res) => {
        if (res.status !== 200) {
          throw new Error(res.status);
        } else {
          resolve();
        }
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const downloadAllFiles = async (
  old_private_key,
  uploadState,
  translations
) => {
  uploadState(translations.downloading_files || "Downloading files...");
  return new Promise((resolve, reject) => {
    const zip = new JSZip();
    fetch(base_url + "user/file/download/all", {
      method: "POST",
      mode: "cors",
      credentials: "include",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
    })
      .then((res) => {
        if (res.status !== 200) return reject();
        else return res.blob();
      })
      .then(async (blob) => {
        console.log("Files downloaded");
        const archive_file = new File([blob], "archive.zip");
        const fileData = await archive_file.arrayBuffer();
        const zipData = await zip.loadAsync(fileData);
        const promises = Object.keys(zipData.files).map((fileName) => {
          return zipData.files[fileName].async("arraybuffer");
        });
        console.log("Files unzipped");
        // Use Promise.all to wait for all the promises to resolve
        const buffers = await Promise.all(promises);

        // Create new File objects from the extracted buffers
        const files = buffers.map((buffer, index) => {
          const fileName = Object.keys(zipData.files)[index];
          return new File([buffer], fileName);
        });
        console.log(files);
        var new_files = [];
        uploadState(translations.decrypting_files || "Decrypting files...");
        Promise.all(
          files.map(async (file) => {
            try {
              const decrypted_file = await decryptFileAES(
                old_private_key,
                file
              );
              new_files.push(
                new File(
                  [decrypted_file],
                  decrypted_file.name.replace("encrypted_", ""),
                  { type: file.type }
                )
              );
            } catch (e) {
              console.log(e);
            }
          })
        )
          .then(() => {
            console.log(new_files);
            resolve(new_files);
          })
          .catch((e) => {
            console.log(e);
            console.log("errorvevfrfdrvfdr");
            reject();
          });
      })
      .catch((e) => {
        console.log("Error downloading all the files");
        console.log(e);
        reject(e);
      });
  });
};
export const uploadAllFiles = async (
  files,
  private_key,
  uploadState,
  translations
) => {
  uploadState(translations.encrypting_files || "Encrypting files...");
  return new Promise(async (resolve, reject) => {
    const formData = new FormData();
    for (let file of files) {
      const encrypted_file = await encryptFileAES(private_key, file);
      formData.append("file", encrypted_file);
    }
    uploadState(translations.uploading_files || "Uploading files");
    fetch(base_url + "user/file/upload/all", {
      method: "POST",
      mode: "cors",
      credentials: "include",
      body: formData,
    })
      .then((res) => {
        if (res.status === 200) return resolve();
        else if (res.status === 413)
          throw new Error("Request entity too large");
        else if (res.status === 403) throw new Error("Unauthorized");
        else throw new Error("A problem occurred");
        // }).then(data=>{
        //     resolve
        //     // if (data.error===""){
        //     //     resolve()
        //     // }
        //     // else if (data.status!==200){
        //     //     reject(data.status)
        //     // }
        //     // else{
        //     //     console.log(data)
        //     //     reject()
        //     // }
      })
      .catch((e) => {
        console.log(e);
        reject("Unable to upload the files");
      });
  });
};
